export default __webpack_public_path__ + "static/media/programming-skills.3bdce3e6.svg";